import React from "react";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";
import { _ } from "../utils/i18n";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UnstyledImage from "./image";

const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-content: ${({ $iconWithLabel }) =>
    $iconWithLabel ? "flex-start" : "center"};
  padding: 1rem 0;
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    padding-block: ${({ $iconWithLabel }) => ($iconWithLabel ? "0" : "1rem")};
  }
`;
const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 3px 7px 3px 0;
  border: ${({ $iconWithLabel, $chipBorderColor }) =>
    $iconWithLabel
      ? `1px solid ${$chipBorderColor || "var(--color-black)"}`
      : "none"};
  border-radius: 6px;
  padding: 0.25rem;
  background: ${({ $iconWithLabel, $chipBg }) =>
    $iconWithLabel && $chipBg ? $chipBg : "transparent"};
  p {
    margin-left: 0.3125rem;
    margin-block: 0;
    font-size: 0.75rem;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    border: none;
    padding-inline: 0.5rem;
    p {
      display: none;
    }
  }
`;

const Icon = styled(FontAwesomeIcon)`
  font-size: ${({ $iconWithLabel }) => ($iconWithLabel ? "1rem" : "1.5rem")};
  color: var(--color-black);
`;

const Image = styled(UnstyledImage)`
  width: ${({ $iconWithLabel }) => ($iconWithLabel ? "1.3rem" : "1.5rem")};
  height: ${({ $iconWithLabel }) => ($iconWithLabel ? "1.3rem" : "1.5rem")};
  filter: ${({ theme }) =>
    theme.isDarkMode ? "grayscale(1) brightness(0) invert(1)" : "none"};
`;

export default function BusFeatures({
  bus,
  iconWithLabel,
  chipBg,
  chipBorderColor,
}) {
  const { wp } = useStaticQuery(graphql`
    query {
      wp {
        crbThemeOptions {
          crbBusFeatures {
            crb_icon_type {
              value
            }
            icon {
              json
            }
            image_svg {
              media {
                localFile {
                  url
                }
              }
            }
            text
          }
        }
      }
    }
  `);

  /** Unite the two arrays, the one with all features (crbBusFeatures) from
   *  Theme Options and the one coming from the chosen features from Multiselect (on every single Bus)
   *  to be able to access icons just for chosen features */
  const chosenFeatures = wp.crbThemeOptions.crbBusFeatures.map((feature) => {
    return {
      ...feature,
      chosenFeat: bus.crbChosenBusFeatures.find(
        (chosenFeat) => chosenFeat.label === feature.text
      ),
    };
  });

  return (
    <Wrapper $iconWithLabel={iconWithLabel}>
      {chosenFeatures &&
        chosenFeatures.map((feature) => (
          <>
            {feature.chosenFeat != undefined && (
              <IconWrapper
                $iconWithLabel={iconWithLabel}
                $chipBg={chipBg}
                $chipBorderColor={chipBorderColor}
              >
                {feature.crb_icon_type.value === "image" ? (
                  <Image
                    $iconWithLabel={iconWithLabel}
                    src={feature.image_svg?.media?.localFile?.url}
                    alt="ikon"
                  />
                ) : (
                  <Icon
                    $iconWithLabel={iconWithLabel}
                    icon={
                      feature.icon?.json ? JSON.parse(feature.icon?.json) : null
                    }
                  />
                )}
                {iconWithLabel && <p>{_(feature.text)}</p>}
              </IconWrapper>
            )}
          </>
        ))}
    </Wrapper>
  );
}

BusFeatures.propTypes = {
  bus: PropTypes.object,
  withText: PropTypes.bool,
  iconWithLabel: PropTypes.bool,
  chipBg: PropTypes.string,
  chipBorderColor: PropTypes.string,
};
